module.exports = __webpack_public_path__ + "static/media/Magnesiano.23858428.png";